import React from 'react';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import withShipment from '../../../withShipment';
import { statusSelector } from '../../../redux/selectors/global';
import { userInfoSelector } from '../../../redux/selectors/auth';
import { clearStatus } from '../../../redux/actions/global';
import { DAYS_OF_WEEK } from '../../global/constants';
import {
  Button,
  CircularProgress,
  Dialog,
  Divider,
  TableCell,
  TextField,
} from '@material-ui/core';
import { AddAPhoto } from '@material-ui/icons';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
import {
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import TopToolbar from '../../global/subcomponents/topToolbar/TopToolbar';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../masterReading/constants';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import {
  addMachinePicture,
  deleteMachinePicture,
  listMachinePicture,
} from '../../../redux/actions/settings';
import {
  allMachinePictureSelector,
  loadingSelector,
} from '../../../redux/selectors/settings';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import styles from '../../../pages/Dashboard/dashboard.css';
import DateFnsUtils from '@date-io/date-fns';
import Utils from '../../Utils/Utils';
import { Layout } from '../../global/Table/TablePageHelpers/LayoutObject';
import { MACHINE_PICTURE_FIELDS } from './constants';
import TablePage from '../../global/Table/TablePage';
import TwoStepDelete from '../../global/subcomponents/twoStepDelete/TwoStepDelete';
import ErrorFeedbackBar from '../../global/ErrorFeedbackBar';
import CloseIcon from '@mui/icons-material/Close';

class MachinePicture extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.innerWidth < 768,
      isCameraOpen: false,
      cameraFacingMode: 'environment',
      newPhotos: [],
      isAddPicture: false,
      previewIndex: null,
      feedbackBarOpen: false,
      feedbackMessage: '',
      feedbackStatus: '',
      machine: '',
      selectedDate: new Date(),
      //table
      isLoading: true,
      deleteId: null,
      search: '',
      openDialog: false,
      dialogImage: null,
    };
    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.refreshComponent();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
    }
  }

  handleImageClick = (imageUrl) => {
    this.setState({ openDialog: true, dialogImage: imageUrl });
  };

  handleDialogClose = () => {
    this.setState({ openDialog: false, dialogImage: null });
  };

  getFormattedFileObject = async (file) => {
    return {
      localURL: URL.createObjectURL(file),
      displayName: file.name,
      type: file.type,
      file,
    };
  };

  startCamera = async () => {
    try {
      const existing = this.videoRef.current?.srcObject;
      if (existing) {
        existing.getTracks().forEach((track) => track.stop());
      }

      const constraints = {
        video: {
          facingMode: { ideal: this.state.cameraFacingMode },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
        audio: false,
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      this.setState({
        isCameraOpen: true,
      });

      if (this.videoRef.current) {
        this.videoRef.current.srcObject = stream;
      }
    } catch (err) {
      alert('Camera access error: ' + err.message);
    }
  };

  switchCamera = () => {
    const nextFacingMode =
      this.state.cameraFacingMode === 'environment' ? 'user' : 'environment';
    this.setState({ cameraFacingMode: nextFacingMode }, () => {
      if (this.state.isCameraOpen) {
        this.startCamera();
      }
    });
  };

  stopCamera = () => {
    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    this.setState({ isCameraOpen: false });
  };

  capturePhoto = () => {
    const canvas = this.canvasRef.current;
    const video = this.videoRef.current;

    if (canvas && video) {
      const width = video.videoWidth;
      const height = video.videoHeight;

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, width, height);

      // Convert canvas to WebP Blob
      canvas.toBlob(
        async (blob) => {
          if (blob) {
            const file = new File(
              [blob],
              `${Date.now() + Math.floor(Math.random() * 10000)}.webp`,
              { type: 'image/webp' }
            );

            const newFile = await this.getFormattedFileObject(file);

            this.setState(
              (prevState) => {
                if (prevState.newPhotos.length >= 3) return null;
                return {
                  isCameraOpen: false,
                  newPhotos: [...prevState.newPhotos, newFile],
                };
              },
              () => {
                this.stopCamera(); // stop camera after setting state
              }
            );
          }
        },
        'image/webp',
        1
      );
    }
  };

  handleOpenCamera = () => {
    if (!this.state.isCameraOpen) {
      this.startCamera();
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;

    // Ensure the value is a positive integer or empty
    const reg = /^[0-9\b]+$/; // Regex to allow only digits and empty input (for clearing the field)

    if (value === '' || reg.test(value)) {
      this.setState({ [name]: value });
    }
  };

  getContextualMenuItems = () => {
    const menuItems = [];

    const { previewIndex, isMobile, isAddPicture } = this.state;

    if (previewIndex !== null) {
      menuItems.push({
        icon: <KeyboardBackspaceIcon />,
        onClick: () => this.setState({ previewIndex: null }),
        title: BACK,
      });
    } else {
      if (isMobile) {
        if (!isAddPicture) {
          menuItems.push({
            icon: <AddCircleIcon />,
            title: 'Add Machine Picture',
            onClick: () => this.setState({ isAddPicture: true }),
          });
        } else {
          menuItems.push({
            icon: <KeyboardBackspaceIcon />,
            onClick: () => this.setState({ isAddPicture: false }),
            title: BACK,
          });
        }
      }
    }

    return menuItems;
  };

  clearFields = () => {
    this.setState({
      isCameraOpen: false,
      newPhotos: [],
      previewIndex: null,
      machine: '',
    });
  };

  handleRemoveFile = (indexToRemove) => {
    const updatedPhotos = this.state.newPhotos.filter(
      (_, index) => index !== indexToRemove
    );
    this.setState({ newPhotos: updatedPhotos });
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    });
  };

  dateSelectRow = () => (
    <div className="dateselectrow">
      <div className={styles.dayOfWeek}>
        <Typography variant="h4">
          {DAYS_OF_WEEK[this.state.selectedDate?.getDay()]}
        </Typography>
      </div>
      <div className="dateLocationBlock">
        <div className={styles.dateField}>
          <KeyboardDatePicker
            autoOk
            style={{ width: '100%' }}
            name="toDate"
            variant="inline"
            inputVariant="outlined"
            label="Date"
            format="yyyy/MM/dd"
            value={this.state.selectedDate}
            InputAdornmentProps={{ position: 'start' }}
            onChange={(date) => this.handleDateChange(date)}
          />
        </div>
      </div>
    </div>
  );

  handleDateChange = (date) => {
    this.setState(
      {
        selectedDate: date,
      },
      () => {
        if (date && !isNaN(date.getTime())) {
          //Only send request when the date is proper
          this.refreshComponent();
        }
      }
    );
  };

  refreshComponent = () => {
    this.props.listMachinePicture({
      date: Utils.formatTodayDate(this.state.selectedDate),
      locationId: this.props.user.selectedLocationId,
    });
  };

  //table

  getTableHeaders = () => {
    let headers = [];
    headers.push(Layout.columnHead(null, null, null));
    MACHINE_PICTURE_FIELDS.forEach((headCell) => {
      headers.push(Layout.columnHead(headCell.label, null, headCell.align));
    });
    return headers;
  };

  tableRow = (data) => {
    const { isLoading } = this.state;

    return (
      <React.Fragment>
        <TableCell />

        <TableCell className="table-cell-left">{data?.machine}</TableCell>

        <TableCell className="table-cell-left" style={{ width: '10%' }}>
          {data?.dateTime}
        </TableCell>

        <TableCell className="table-cell-left" style={{ width: '65%' }}>
          <div className="images-container">
            {isLoading && (
              <div className="loading-indicator">
                <CircularProgress />
              </div>
            )}
            {data?.files?.map((file, index) => (
              <img
                key={index}
                src={file.localURL}
                alt={`Customer-${index}`}
                className="responsive-image-machine"
                onClick={() => this.handleImageClick(file.localURL)}
                style={{
                  cursor: 'pointer',
                }}
                onLoad={this.handleImageLoad}
                onError={this.handleImageError}
              />
            ))}
          </div>
        </TableCell>
        <TwoStepDelete
          rowId={data.machinePictureId}
          handleDelete={(rowIdToDelete) =>
            this.props.deleteMachinePicture({
              machinePictureId: data.machinePictureId,
              date: Utils.formatTodayDate(this.state.selectedDate),
            })
          }
          deleteId={this.state.deleteId}
          setDeleteId={(newDeleteId) =>
            this.setState({ deleteId: newDeleteId })
          }
        />
        <TableCell />
      </React.Fragment>
    );
  };

  searchStrings = (data) => {
    return [data.machine, data.dateTime];
  };

  handleImageLoad = () => {
    this.setState({ isLoading: false });
  };

  handleImageError = () => {
    this.setState({ isLoading: false });
  };

  render() {
    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <TopToolbar
          pageName={
            this.state.isAddPicture ? 'Add Machine Picture' : 'Machine Picture'
          }
          menuItems={this.getContextualMenuItems()}
        />

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleDialogClose}
          maxWidth="md"
          fullWidth
        >
          <div style={{ position: 'relative' }}>
            <IconButton
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                color: '#fff',
                backgroundColor: '#0007',
              }}
              onClick={this.handleDialogClose}
            >
              <CloseIcon />
            </IconButton>
            <img
              src={this.state.dialogImage}
              alt="Full-size"
              style={{ width: '100%', height: 'auto', borderRadius: '4px' }}
            />
          </div>
        </Dialog>

        {this.state.previewIndex !== null ? (
          <img
            src={this.state.newPhotos[this.state.previewIndex].localURL}
            alt="Machine Reading"
            className="responsive-image-full-screen"
          />
        ) : this.state.isAddPicture ? (
          <>
            {!this.state.isCameraOpen && (
              <>
                <div className="rowSpecMaster" style={{ marginTop: '32px' }}>
                  <TextField
                    className="input-text-field"
                    variant="outlined"
                    label="Machine"
                    InputLabelProps={{ shrink: true }}
                    name="machine"
                    value={this.state.machine}
                    onChange={this.handleChange}
                    type="tel"
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      min: '0',
                      step: '1',
                    }}
                  />
                </div>

                <div style={{ marginLeft: '16px', marginRight: '16px' }}>
                  <h5 style={{ marginTop: '16px' }}>Pictures</h5>
                  <Divider style={{ marginTop: '16px' }} />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'flex-start',
                      marginTop: '8px',
                    }}
                  >
                    {this.state.newPhotos.length < 3 && (
                      <Button
                        style={{ marginTop: '16px' }}
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={this.handleOpenCamera}
                        startIcon={<AddAPhoto />}
                        aria-label="Open Camera"
                      >
                        Add Photo
                      </Button>
                    )}
                  </div>

                  <List style={{ marginTop: '16px' }}>
                    {this.state.newPhotos.map((file, index) => (
                      <ListItem
                        key={index}
                        style={{
                          borderBottom: '1px solid #eee',
                          paddingLeft: '8px',
                          paddingRight: '8px',
                        }}
                        secondaryAction={
                          <>
                            <Tooltip title="Preview">
                              <IconButton
                                onClick={() =>
                                  this.setState({ previewIndex: index })
                                }
                                size="medium"
                              >
                                <VisibilityIcon fontSize="24px" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title="Remove"
                              style={{ marginLeft: '8px' }}
                            >
                              <IconButton
                                onClick={() => this.handleRemoveFile(index)}
                                size="medium"
                              >
                                <DeleteIcon fontSize="24px" color="error" />
                              </IconButton>
                            </Tooltip>
                          </>
                        }
                      >
                        <ListItemIcon>
                          <InsertDriveFileIcon color="primary" />
                        </ListItemIcon>

                        <ListItemText
                          primary={
                            <Typography
                              noWrap
                              style={{
                                maxWidth: '180px', // Adjust based on your layout
                                color: '#1976d2',
                                fontWeight: 500,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {file.displayName}
                            </Typography>
                          }
                          primaryTypographyProps={{
                            style: { color: '#1976d2', fontWeight: 500 },
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </div>
              </>
            )}

            <div className="rowSpecMaster">
              {this.state.isCameraOpen && (
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    maxHeight: '50vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <video
                    ref={this.videoRef}
                    autoPlay
                    playsInline
                    muted
                    style={{ width: '100%', height: 'auto' }}
                  />

                  <button
                    onClick={this.capturePhoto}
                    style={{
                      ...styless.captureButton,
                    }}
                  >
                    <span style={styless.captureIcon}></span>
                  </button>
                  <button
                    type="button"
                    onClick={this.switchCamera}
                    aria-label="Switch Camera"
                    style={styless.flipButton}
                  >
                    <FlipCameraIosIcon />
                  </button>
                </div>
              )}

              {/* Hidden canvas for capturing image */}
              <canvas ref={this.canvasRef} style={{ display: 'none' }} />
            </div>

            {!this.state.isCameraOpen && (
              <div
                className="rowSpecSaveButtons"
                style={{ marginBottom: '24px' }}
              >
                <Button
                  variant="outlined"
                  onClick={this.clearFields}
                  className="register-new-user_btn"
                >
                  CLEAR
                </Button>
                <Button
                  className="register-new-user_btn"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    const callback = (status, response) => {
                      if (!status) {
                        this.openFeedbackBar('error', response);
                      } else {
                        this.openFeedbackBar('success', response);
                        this.clearFields();
                        this.setState({ isAddPicture: false }, () => {
                          this.refreshComponent();
                        });
                      }
                    };
                    this.props.addMachinePicture(
                      {
                        locationId: this.props.user.selectedLocationId,
                        userId: this.props.user.userId,
                        machine: this.state.machine,
                        newPhotos: this.state.newPhotos,
                      },
                      callback
                    );
                  }}
                  disabled={
                    this.props.loadingData ||
                    !(this.state.machine && this.state.newPhotos.length > 0)
                  }
                >
                  {this.props.loadingData ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    'SAVE'
                  )}
                </Button>
              </div>
            )}
          </>
        ) : (
          //Table View
          <>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              {this.dateSelectRow()}
            </MuiPickersUtilsProvider>

            <TablePage
              tableName="CustomerTable"
              tableRows={this.props.allMachinePictures}
              tableColumnHeads={this.getTableHeaders()}
              tableRow={this.tableRow}
              paginationText="Results"
              // defaultSortBy="machine"
              // searchStrings={this.searchStrings}
              // hasSearchField
            />
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  user: userInfoSelector(state),
  allMachinePictures: allMachinePictureSelector(state),
  loadingData: loadingSelector(state),
});

const actionCreators = {
  clearStatus,
  addMachinePicture,
  listMachinePicture,
  deleteMachinePicture,
};

const styless = {
  captureButton: {
    position: 'absolute',
    bottom: '0px',
    left: '50%',
    transform: 'translateX(-50%)',
    border: 'none',
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0',
  },
  captureIcon: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: '#333',
  },
  flipButton: {
    position: 'absolute',
    bottom: '6px',
    right: '12px',
    border: 'none',
    borderRadius: '50%',
    width: '44px',
    height: '44px',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0',
  },
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  MachinePicture
);
